export enum UserActivitityTrendEnum {
  LicensedUsers = 1,
  DAUC = 2,
  DULAC = 3,
}
